import { useState, useEffect } from "react";
import Confetti from "react-confetti";

const ConfettiLayer = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
    const timer = setTimeout(() => setShow(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  return show ? <Confetti recycle={false} numberOfPieces={300} gravity={0.05} /> : null;
};

export default ConfettiLayer;